import ReactOnRails from 'react-on-rails';

import FrontSite from '../src/front_site/FrontSiteClient';

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({
  FrontSite,
});
